import { render, staticRenderFns } from "./TreatmentView.vue?vue&type=template&id=5fcc495c&scoped=true"
import script from "./TreatmentView.vue?vue&type=script&lang=js"
export * from "./TreatmentView.vue?vue&type=script&lang=js"
import style0 from "./TreatmentView.vue?vue&type=style&index=0&id=5fcc495c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc495c",
  null
  
)

export default component.exports